module.exports = __webpack_public_path__ + "media/Cars_driving_night.b75c2aa3.mp4";